import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e13ddf56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "follow-dialog" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "公司", -1))
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "渠道", -1))
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户编码", -1))
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "info-item info-item-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "客户名称", -1))
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "业务员", -1))
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = { class: "summary-grid" }
const _hoisted_19 = { class: "summary-card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "应收账款余额", -1))
const _hoisted_21 = { class: "summary-value" }
const _hoisted_22 = { class: "summary-card" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "逾期金额小计", -1))
const _hoisted_24 = { class: "summary-value" }
const _hoisted_25 = { class: "summary-card" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "付款条件", -1))
const _hoisted_27 = { class: "summary-value" }
const _hoisted_28 = { class: "summary-card" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "风险等级", -1))
const _hoisted_30 = { class: "summary-value" }
const _hoisted_31 = { class: "summary-card" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "分支财务", -1))
const _hoisted_33 = { class: "summary-value" }
const _hoisted_34 = { class: "summary-card" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "数据同步时间", -1))
const _hoisted_36 = { class: "summary-value" }
const _hoisted_37 = { class: "section" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "反馈记录", -1))
const _hoisted_39 = {
  key: 0,
  class: "log-empty"
}
const _hoisted_40 = {
  key: 1,
  class: "log-timeline"
}
const _hoisted_41 = { class: "log-axis" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-dot" }, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "log-line"
}
const _hoisted_44 = { class: "log-content" }
const _hoisted_45 = { class: "log-time" }
const _hoisted_46 = { class: "log-card" }
const _hoisted_47 = { class: "log-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "预期回款金额：", -1))
const _hoisted_49 = { class: "log-value" }
const _hoisted_50 = { class: "log-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "预计回款日期：", -1))
const _hoisted_52 = { class: "log-value" }
const _hoisted_53 = { class: "log-row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "原因及说明：", -1))
const _hoisted_55 = { class: "log-value" }
const _hoisted_56 = { class: "log-row log-row-attachments" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "附件：", -1))
const _hoisted_58 = { class: "log-value" }
const _hoisted_59 = ["href", "title"]
const _hoisted_60 = { class: "section" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "风险等级修改记录", -1))
const _hoisted_62 = {
  key: 0,
  class: "log-empty"
}
const _hoisted_63 = {
  key: 1,
  class: "log-timeline"
}
const _hoisted_64 = { class: "log-axis" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-dot" }, null, -1))
const _hoisted_66 = {
  key: 0,
  class: "log-line"
}
const _hoisted_67 = { class: "log-content" }
const _hoisted_68 = { class: "log-time" }
const _hoisted_69 = { class: "log-card" }
const _hoisted_70 = { class: "log-row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "风险等级：", -1))
const _hoisted_72 = { class: "log-value" }
const _hoisted_73 = { class: "log-row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "风险等级原因：", -1))
const _hoisted_75 = { class: "log-value" }
const _hoisted_76 = { class: "log-row" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "逾期原因及说明：", -1))
const _hoisted_78 = { class: "log-value" }
const _hoisted_79 = { class: "log-row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "log-label" }, "是否起诉客户：", -1))
const _hoisted_81 = { class: "log-value" }
const _hoisted_82 = { class: "follow-footer" }

import { ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type {
  FollowUpFeedbackRecordLogItem,
  FollowUpRiskRecordLogItem,
  ReceivableCustomerItem,
} from './index';
import { queryFollowUpRecords } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'FollowRecordsDialog',
  props: {
    visible: { type: Boolean },
    record: null
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  record: ReceivableCustomerItem | null;
}





const loading = ref(false);
const feedbackLogs = ref<FollowUpFeedbackRecordLogItem[]>([]);
const riskLogs = ref<FollowUpRiskRecordLogItem[]>([]);

function displayValue(value?: string | number | null) {
  if (value === null || value === undefined || value === '') return '-';
  return String(value);
}

function formatYesNo(value?: number | string | boolean) {
  if (value === 1 || value === '1' || value === true || value === 'true' || value === '是') {
    return '是';
  }
  if (value === 0 || value === '0' || value === false || value === 'false' || value === '否') {
    return '否';
  }
  return '-';
}

function fileUrls(value?: string | string[]) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || '').trim()).filter(Boolean);
  }
  const text = String(value ?? '').trim();
  if (!text) return [];
  return text
    .split(/[,;，；\n]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

/** 从 OBS URL 解析附件原始文件名 */
function fileNameFromUrl(url: string) {
  try {
    const path = url.split('?')[0] || url;
    const raw = path.substring(path.lastIndexOf('/') + 1);
    const decoded = decodeURIComponent(raw);
    return decoded || url;
  } catch {
    return url;
  }
}

function attachmentFiles(item: FollowUpFeedbackRecordLogItem) {
  const unique = [...new Set(fileUrls(item.customerFileUrl))];
  return unique.map((url) => ({
    url,
    name: fileNameFromUrl(url),
  }));
}

watch(
  () => props.visible,
  async (open) => {
    if (!open) {
      feedbackLogs.value = [];
      riskLogs.value = [];
      return;
    }
    await fetchLogs();
  },
);

async function fetchLogs() {
  const sapCustomerCode = (props.record?.customerCode || '').trim();
  const dissaleChannelCode = (props.record?.dissaleChannelCode || '').trim();
  if (!sapCustomerCode || !dissaleChannelCode) {
    message.error('缺少客户编码或渠道信息，无法查询跟进记录');
    feedbackLogs.value = [];
    riskLogs.value = [];
    return;
  }

  loading.value = true;
  try {
    const result = await queryFollowUpRecords({
      dissaleChannelCode,
      sapCustomerCode,
      corpCode: (props.record?.corpCode || '').trim(),
    });
    feedbackLogs.value = result.feedbackLogs;
    riskLogs.value = result.riskLogs;
  } catch (error) {
    feedbackLogs.value = [];
    riskLogs.value = [];
    message.error(error instanceof Error ? error.message : '查询跟进记录失败');
  } finally {
    loading.value = false;
  }
}

function handleCancel() {
  emit('update:visible', false);
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "查看跟进记录",
    width: 760,
    "mask-closable": false,
    "destroy-on-close": "",
    class: "follow-records-modal",
    onCancel: handleCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_82, [
        _createVNode(_component_a_button, { onClick: handleCancel }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.record?.corpCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.record?.channel || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(__props.record?.customerCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", {
              class: "info-value",
              title: __props.record?.customerName || '-'
            }, _toDisplayString(__props.record?.customerName || '-'), 9, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(__props.record?.salesman || '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(displayValue(__props.record?.receivableBalance)), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, _toDisplayString(displayValue(__props.record?.overdueTotal)), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(displayValue(__props.record?.paymentTerm)), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(displayValue(__props.record?.riskLevel)), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(displayValue(__props.record?.financeOwner)), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, _toDisplayString(displayValue(__props.record?.syncAt)), 1)
          ])
        ]),
        _createVNode(_component_a_spin, { spinning: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              (!loading.value && !feedbackLogs.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, "暂无反馈记录"))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedbackLogs.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `fb-${index}`,
                        class: "log-item"
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          (index < feedbackLogs.value.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createTextVNode(_toDisplayString(item.createDate || '-') + " ", 1),
                            (item.createName || item.createWorkCode)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" | " + _toDisplayString(item.createName || item.createWorkCode || '-') + " ", 1),
                                  (item.createName && item.createWorkCode)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" (" + _toDisplayString(item.createWorkCode) + ") ", 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createElementVNode("span", _hoisted_49, _toDisplayString(displayValue(item.expectRepayAmount)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createElementVNode("span", _hoisted_52, _toDisplayString(item.expectRepayDate || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _hoisted_54,
                              _createElementVNode("span", _hoisted_55, _toDisplayString(item.feedbackMessage || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createElementVNode("span", _hoisted_58, [
                                (attachmentFiles(item).length)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(attachmentFiles(item), (file, fileIdx) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: `${file.url}-${fileIdx}`,
                                        class: "file-link",
                                        href: file.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        title: file.name
                                      }, _toDisplayString(file.name), 9, _hoisted_59))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              (!loading.value && !riskLogs.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, "暂无风险修改记录"))
                : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(riskLogs.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `risk-${index}`,
                        class: "log-item"
                      }, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          (index < riskLogs.value.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createTextVNode(_toDisplayString(item.createDate || '-') + " ", 1),
                            (item.createName || item.createWorkCode)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" | " + _toDisplayString(item.createName || '-') + " ", 1),
                                  (item.createWorkCode)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("(" + _toDisplayString(item.createWorkCode) + ")", 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("span", _hoisted_72, _toDisplayString(item.riskLevel || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _hoisted_74,
                              _createElementVNode("span", _hoisted_75, _toDisplayString(item.riskReason || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _createElementVNode("span", _hoisted_78, _toDisplayString(item.riskDesc || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _hoisted_80,
                              _createElementVNode("span", _hoisted_81, _toDisplayString(formatYesNo(item.isProsecute)), 1)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})